import React from "react";
import Spinner from 'react-spinner';
import { browserHistory } from 'react-router';

import fetchContent from '../../helpers/backend-communication';
import { CountrySelect } from '../Selects';
import DataMap, { DataMapLegend } from './DataMap';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: false
    }
  }

  componentDidMount() {
    console.log("Fetching content for map....");

    this.setState({
      isLoading: true
    });

    fetchContent('lastReports')
      .then(responseObject => {
        this.setState({
          data: responseObject,
          isLoading: false
        });
      })
      .catch(error => {
        console.error('Fetch Map content went wrong', error);
        this.setState({
          data: null,
          isLoading: false
        });
      });

    window.addEventListener('resize', this.resize);
  }


  handleCountrySelect(countryCode) {
    const countryData = this.state.data && this.state.data[countryCode];

    if (countryData && countryData.reporting_year < 2020) {
      browserHistory.push(`/national-reports?country=${countryCode}&year=`);
    } else {
      browserHistory.push(`/country-profiles/${countryCode}`);
    }
  }

  renderMap() {
    let map;

    if (this.state.isLoading) {
      map = <Spinner className="home-map__spinner" />;
    } else if (this.state.data) {
      map = (
        <DataMap
          data={ this.state.data }
          onSelect={ this.handleCountrySelect.bind(this) }
        />
      );
    } else {
      map = <p>No map information available.</p>;
    }

    return map
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-4">
            <CountrySelect
              onSelect={ selected => this.handleCountrySelect(selected.value) }
            />
          </div>
          <div className="col-sm-8">
            <div className="home-map">
              { this.renderMap() }
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <DataMapLegend />
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.js